import axios from 'index/axios'

// 查询当前用户在项目中的角色
export function getMyRole(projectId) {
    return axios.get(`/QcReview/myRole/${projectId}`)
}

// 取店池（兼职QC用）
export function getQcPool(params) {
    return axios.post('/QcReview/pool', params)
}

// 待分配池（内部QC用）
export function getQcPending(params) {
    return axios.post('/QcReview/pending', params)
}

// 兼职QC取店
export function claimDealers(params) {
    return axios.post('/QcReview/claim', params)
}

// 兼职QC释放门店
export function releaseDealers(params) {
    return axios.post('/QcReview/release', params)
}

// 内部QC指派门店
export function assignDealers(params) {
    return axios.post('/QcReview/assign', params)
}

// 内部QC驳回门店
export function rejectDealers(params) {
    return axios.post('/QcReview/reject', params)
}

// ===== 42 号方案 §10.8：门店级作废 / 恢复 =====

// 作废门店（整店退回神客重新做）
export function voidDealer(data) {
    return axios.post('/QcReview/void-dealer', data)
}

// 恢复门店（有冲突时需指定 conflictResolution: 'overwrite' | 'abort'）
export function unvoidDealer(data) {
    return axios.post('/QcReview/unvoid-dealer', data)
}

// 查询门店作废日志时间线
export function getDealerVoidLog(waveId, dealerCode) {
    return axios.get(`/QcReview/dealer-void-log/${waveId}/${encodeURIComponent(dealerCode)}`)
}

// 批量查询门店当前作废状态（Data.vue 列表用）
export function getDealerVoidStatus(data) {
    return axios.post('/QcReview/dealer-void-status', data)
}
